import { Orbit, Rocket, Sparkles } from "lucide-react";

// Add new games here; status "soon" shows a Coming Soon cabinet
export const GAMES = [
  {
    id: "asteroids",
    name: "Asteroids",
    icon: Orbit,
    color: "#00F0FF",
    status: "live",
    desc: "Fly free through deep space and blast drifting rocks and enemy ships.",
    controls: "Arrow keys to fly, Space to shoot",
    image: "https://static.prod-images.emergentagent.com/jobs/a281e9df-f7f2-4ec5-a8af-d3270d0ad80f/images/bae768cf3e246e6698322ec6c645618e559c70b959b7ab81fbcdd29ed6dfde45.jpeg",
  },
  {
    id: "invaders",
    name: "Space Invaders",
    icon: Rocket,
    color: "#FF2BD6",
    status: "live",
    desc: "3D alien waves that fire back at 0:30 and dive-bomb at 1:00. How long can you last?",
    controls: "Left / Right to move, Space to shoot",
    image: "https://static.prod-images.emergentagent.com/jobs/a281e9df-f7f2-4ec5-a8af-d3270d0ad80f/images/05c3e4efc8033dad4bbdc52714fd257dc8ef99cd2a0d0f97f1a4e1d934ced132.jpeg",
  },
  {
    id: "mystery",
    name: "Mystery Game",
    icon: Sparkles,
    color: "#FFE600",
    status: "soon",
    desc: "A brand new game is being built for the arcade. Stay tuned!",
  },
];

export const getGame = (id) => GAMES.find((g) => g.id === id && g.status === "live");
